import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import {
  addUser,
  addAppData,
  addSettings,
  addAllNotifications,
} from "../app/Slices";
import { useApi } from "@/";
import { LoadingScreen } from "@/components";

const ProtectedRoute = ({ requiredPermission }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state?.user?.user);
  const navigate = useNavigate();
  const { callApi } = useApi();
  const [authLoading, setAuthLoading] = useState(true);
  const token = localStorage.getItem("token");

  const authUser = async () => {
    try {
      const res = await callApi("/common/authMe", "POST");

      if (!res.success) {
        console.error("Error authenticating user:", res.error);
        return navigate("/login");
      }

      const config = res?.data?.config;

      dispatch(addUser(res?.data?.user));
      dispatch(addAppData(config?.app));
      dispatch(addSettings(config.settings));
      dispatch(addAllNotifications(config.notifications));

      if (res?.data?.needsRefresh) {
        const response = await callApi("/common/refresh-token", "POST", {
          token: localStorage.getItem("refreshToken"),
        });
        if (!response.success) {
          console.error("Error refreshing token:", response.error);
          return navigate("/login");
        }
        localStorage.setItem("token", response.data?.token);
        console.log("Token refreshed successfully");
      }
      setAuthLoading(false);
    } catch (err) {
      console.error("Error in auth flow:", err || "Unknown error");
      navigate("/login");
    }
  };
  useEffect(() => {
    if (!user && token) {
      authUser();
    } else {
      setAuthLoading(false);
    }
  }, [user]); // Include 'user' so effect runs when user changes

  if (authLoading) {
    return <LoadingScreen />;
  }

  if (
    requiredPermission &&
    user?.role === "Admin-Employee" &&
    !user.permissions.includes(requiredPermission)
  ) {
    return <Navigate to="/unauthorizedUser" />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
